<template>
  <div class="wrapper">
		<div v-if="loading" class="text-center">
			<b-spinner label="Loading..." style="width: 3rem; height: 3rem;" variant="info"></b-spinner>
		</div>
    <div v-else class="animated fadeIn">
      <b-row v-show="false">
        <b-col cols="12">
          <b-card header-tag="header">
            <div slot="header"><i class="icon-wrench"></i> Billing Setup</div>
            <b-form @submit.prevent="checkFormValidity()" method="post">
							<b-form-group
								label="Pricing Option"
								label-for="pricingOption"
								label-class="required"
								:label-cols="3"
								:horizontal="true">
								<b-form-radio-group v-model="form.pricingOption"
																		name="pricingOption"
																		id="pricingOption"
																		:plain="true"
																		:options="pricingOptionList"
																		aria-describedby="pricingOption-live-feedback">
								</b-form-radio-group>
								<b-form-invalid-feedback id="pricingOption-live-feedback" :state="!$v.form.pricingOption.$error">Please select one.</b-form-invalid-feedback>
							</b-form-group>
							<b-form-group
								v-if="form.pricingOption === 2"
								label="Select Purchase Order"
								label-for="purchaseOrder"
								label-class="required"
								:label-cols="3"
								:horizontal="true"
								invalid-feedback="Please select one."
								:state="$v.form.purchaseOrderId.$dirty ? !$v.form.purchaseOrderId.$error : null">
								<model-select id="purchaseOrder" :options="purchaseOrderDropDownList" v-model="form.purchaseOrderId" :isError="$v.form.purchaseOrderId.$dirty ? $v.form.purchaseOrderId.$error : false" placeholder="Select Purchase Order"></model-select>
							</b-form-group>
              <b-form-group
                label="Select Project"
                label-for="projectName"
								label-class="required"
                :label-cols="3"
                :horizontal="true"
								invalid-feedback="Please select one."
								:state="$v.form.projectId.$dirty ? !$v.form.projectId.$error : null">
								<model-select id="projectName" :options="projectNameDropDownList" v-model="form.projectId" :isError="$v.form.projectId.$dirty ? $v.form.projectId.$error : false" placeholder="Select Project Name"></model-select>
              </b-form-group>
              <b-form-group
                label="Subscription Period"
                label-for="subscriptionPeriod"
								label-class="required"
                :label-cols="3"
                :horizontal="true">
                <b-form-radio-group v-model="form.subscriptionPeriod"
                                    name="subscriptionPeriod"
                                    id="subscriptionPeriod"
                                    :plain="true"
                                    :options="subscriptionPeriodList"
																		:disabled="form.pricingOption === 2"
                                    aria-describedby="subscriptionPeriod-live-feedback">
                </b-form-radio-group>
                <b-form-invalid-feedback id="subscriptionPeriod-live-feedback" :state="!$v.form.subscriptionPeriod.$error">Please select one.</b-form-invalid-feedback>
              </b-form-group>
              <b-form-group
                label="Payment Option"
                label-for="paymentOption"
								label-class="required"
                :label-cols="3"
                :horizontal="true">
                <b-form-radio-group v-model="form.paymentOption"
                                    name="paymentOption"
                                    id="paymentOption"
                                    :plain="true"
                                    :options="paymentOptionList"
																		:disabled="form.pricingOption === 2"
                                    aria-describedby="paymentOption-live-feedback">
                </b-form-radio-group>
                <b-form-invalid-feedback id="paymentOption-live-feedback" :state="!$v.form.paymentOption.$error">Please select one.</b-form-invalid-feedback>
              </b-form-group>
							<b-form-group
								v-if="form.pricingOption === 2 && form.purchaseOrderId !== null"
								label="Number of Devices"
								:label-cols="3"
								:horizontal="true">
								<b-form-input plaintext :value="deviceQuantity"></b-form-input>
							</b-form-group>
							<b-form-group
								v-if="form.pricingOption === 2 && form.purchaseOrderId !== null"
								label="Device Unit Price"
								:label-cols="3"
								:horizontal="true">
								<b-form-input plaintext :value="deviceUnitPrice"></b-form-input>
							</b-form-group>
							<b-form-group
								v-if="form.pricingOption === 2 && form.purchaseOrderId !== null"
								label="Software Package Fee"
								:label-cols="3"
								:horizontal="true">
								<b-form-input plaintext :value="softwarePackageFee"></b-form-input>
							</b-form-group>
              <b-form-group
                label="Amount"
                label-for="amount"
								label-class="required"
                :label-cols="3"
                :horizontal="true">
                <b-form-input v-model="form.amount" name="amount" id="amount" type="number" placeholder="Amount" :state="$v.form.amount.$dirty ? !$v.form.amount.$error : null" aria-describedby="amount-live-feedback"></b-form-input>
                <b-form-invalid-feedback id="amount-live-feedback">This is a required field and must not be 0.</b-form-invalid-feedback>
              </b-form-group>
              <b-form-group
                label="Late Fee Percentage"
                label-for="lateFeePercentage"
                :label-cols="3"
                :horizontal="true">
                <b-form-input v-model="form.lateFeePercentage" name="lateFeePercentage" id="lateFeePercentage" type="number" placeholder="Late Fee Percentage" min="0"></b-form-input>
              </b-form-group>
<!--              <b-form-group-->
<!--                label="Trial Start Date" label-for="trialStartDate"-->
<!--                :label-cols="3"-->
<!--                :horizontal="true">-->
<!--                <b-form-input v-model="form.trialStartDate" name="trialStartDate" type="date" id="trialStartDate"></b-form-input>-->
<!--              </b-form-group>-->
<!--              <b-form-group-->
<!--                label="Trial End Date" label-for="trialEndDate"-->
<!--                :label-cols="3"-->
<!--                :horizontal="true">-->
<!--                <b-form-input v-model="form.trialEndDate" name="trialEndDate" type="date" id="trialEndDate" :state="$v.form.trialEndDate.$dirty ? !$v.form.trialEndDate.$error : null" aria-describedby="trialEndDate-live-feedback"></b-form-input>-->
<!--                <b-form-invalid-feedback id="trialEndDate-live-feedback">Trial end date is required.</b-form-invalid-feedback>-->
<!--              </b-form-group>-->
							<b-form-group
								v-if="form.pricingOption === 2 && form.purchaseOrderId !== null"
								label="Delivery Date"
								:label-cols="3"
								:horizontal="true">
								<b-form-input plaintext :value="deliveryDate"></b-form-input>
							</b-form-group>
              <b-form-group
                label="Bill Generation Start Date" label-for="billGenerationStartDate"
								label-class="required"
                :label-cols="3"
                :horizontal="true">
                <b-form-input v-model="form.billGenerationStartDate" name="billGenerationStartDate" type="date" id="billGenerationStartDate" :state="$v.form.billGenerationStartDate.$dirty ? !$v.form.billGenerationStartDate.$error : null" aria-describedby="billGenerationStartDate-live-feedback"></b-form-input>
                <b-form-invalid-feedback id="billGenerationStartDate-live-feedback">This is a required field.</b-form-invalid-feedback>
              </b-form-group>
              <b-form-group
                label="Status"
                label-for="status"
								label-class="required"
                :label-cols="3"
                :horizontal="true">
                <b-form-radio-group v-model="form.status"
                                    name="status"
                                    id="status"
                                    :plain="true"
                                    :options="statusList"
                                    aria-describedby="status-live-feedback">
                </b-form-radio-group>
                <b-form-invalid-feedback id="status-live-feedback" :state="!$v.form.status.$error">Please select one.</b-form-invalid-feedback>
              </b-form-group>
              <div class="form-actions">
                <b-button type="submit" variant="primary"><i class="fa fa-dot-circle-o"></i> Add New Subscriber</b-button>
                &nbsp;
                <b-button type="button" variant="danger" @click="resetForm()"><i class="fa fa-ban"></i> Reset</b-button>
              </div>
            </b-form>
          </b-card>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
					<div class="animated fadeIn">
						<genericTable :table-data="tableData" :filter="true" :lazy-filter-enabled="true" :fields="fields" :per-page="searchParams.perPage"
													:search-method="searchSubscription" :filter-and-pagination-status="filterAndPaginationStatus"
													hover striped bordered small
													caption="<i class='icon-list'></i> List of Subscribers">
							<template v-slot:row-actions="row">
								<b-button v-if="row.row.item.status !== -1" size="sm" variant="warning" class="mr-1" @click="showEditModal(row.row.item)" v-b-tooltip.hover title="Edit" active v-b-modal.subscription-edit-modal>
									<i class="icon-pencil"></i>
								</b-button>
								<b-button v-if="row.row.item.status !== -1" size="sm" variant="danger" class="mr-1" @click="openDeleteConfirmationModal(row.row.item)" v-b-tooltip.hover title="Delete" active v-b-modal.delete-confirmation-modal>
									<i class="fa fa-trash-o"></i>
								</b-button>
							</template>
						</genericTable>
					</div>
        </b-col>
      </b-row>
			<b-modal id="delete-confirmation-modal"
							 title-html="<i class='icon-info'></i> Confirmation"
							 header-bg-variant="dark"
							 header-text-variant="light"
							 ok-title="Delete"
							 ok-variant="danger"
							 @ok="handleOk"
							 @cancel="cancelDeleteOperation">
				Are you sure you want to delete the subscription for {{subscriptionToBeDeleted.projectName}}?
			</b-modal>
			<b-modal id="subscription-edit-modal"
							 :title-html="editForm.title"
							 header-text-variant="light"
							 header-bg-variant="dark"
							 :ok-title="editForm.okTitle"
							 :ok-disabled="editForm.disabled"
							 @ok="handleOk"
							 @cancel="resetEditForm"
							 @close="resetEditForm">
				<b-form @submit.prevent="checkEditFormValidity()" method="post">
					<b-form-group
						label="BIN"
						label-for="new-bin"
						:label-cols="3"
						:horizontal="true">
						<b-form-input v-model="editForm.bin" name="bin" id="new-bin" type="text" :disabled="editForm.disabled"></b-form-input>
					</b-form-group>
					<b-form-group
						label="Address"
						label-for="new-address"
						:label-cols="3"
						:horizontal="true">
						<b-form-textarea id="new-address" v-model="editForm.address" placeholder="" rows="3" max-rows="6" :disabled="editForm.disabled"></b-form-textarea>
					</b-form-group>
					<b-form-group
						label="Invoice Number Prefix"
						label-for="new-invoice-no-prefix"
						:label-cols="3"
						:horizontal="true">
						<b-form-input v-model="editForm.invoiceNumberPrefix" name="invoice_no_prefix" id="new-invoice-no-prefix" type="text" :disabled="editForm.disabled"></b-form-input>
					</b-form-group>
					<b-form-group
						label="Amount"
						label-for="new-amount"
						:label-cols="3"
						:horizontal="true">
						<b-form-input v-model="editForm.amount" name="amount" id="new-amount" type="number" placeholder="Amount"
													:state="$v.editForm.amount.$dirty ? !$v.editForm.amount.$error : null"
													min="1" @mousewheel.native="$event.preventDefault()"
													aria-describedby="new-amount-live-feedback" :disabled="editForm.disabled"></b-form-input>
						<b-form-invalid-feedback id="new-amount-live-feedback">This field must not be 0.</b-form-invalid-feedback>
					</b-form-group>
					<b-form-group
						label="SD"
						label-for="new-sd-amount"
						:label-cols="3"
						:horizontal="true">
						<b-form-input v-model="editForm.sdAmount" name="sd_amount" id="new-sd-amount" type="number" min="0" placeholder="0.0" @mousewheel.native="$event.preventDefault()" :disabled="editForm.disabled"></b-form-input>
					</b-form-group>
					<b-form-group
						label="Discount"
						label-for="new-discount"
						:label-cols="3"
						:horizontal="true">
						<b-form-input v-model="editForm.discount" name="discount" id="new-discount" type="number" min="0" placeholder="0.0" @mousewheel.native="$event.preventDefault()" :disabled="editForm.disabled"></b-form-input>
					</b-form-group>
				</b-form>
			</b-modal>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { required, numeric, minValue, requiredIf } from 'vuelidate/lib/validators';
import officeService from '@/services/officeService';
import subscriptionService from "@/services/subscriptionService";
import genericTable from '@/components/GenericTable';
import toastService from "@/services/toastService";
import purchaseOrderService from "@/services/purchaseOrderService";
import customerService from "@/services/customerService";
import {ModelSelect} from "vue-search-select";

export default {
  name: 'setup',
	components: {
		"genericTable": genericTable,
		ModelSelect
	},
  data: function(){
    return{
      form: {
      	purchaseOrderId: null,
				projectId: null,
        subscriptionPeriod: 2,
        pricingOption: 1,
        paymentOption: 1,
        amount: null,
        lateFeePercentage: null,
        trialStartDate: null,
        trialEndDate: null,
        billGenerationStartDate: null,
        status: 1
      },
			editForm: {
				title: null,
      	subscriptionId: null,
      	amount: null,
				sdAmount: null,
				discount: null,
				address: null,
				invoiceNumberPrefix: null,
				bin: null,
				okTitle: "Update",
				disabled: false

			},
			purchaseOrderDropDownList: [],
      subscriptionPeriodList: [],
      pricingOptionList: [],
      paymentOptionList: [],
			projectNames : [],
			projectNameDropDownList : [],
      statusList: [
        {text: 'Active ',value: 1},
        {text: 'Inactive ',value: 0}
      ],
			purchaseOrderList: [],
			subscriptionList: [],
			fields: [
				{key: 'id', label: 'ID', sortable: false, thStyle: "width: 2%"},
				{key: 'project_name', label: 'Project Name', sortable: false},
				{key: 'bin', label: 'BIN', sortable: false},
				{key: 'subscription_period', label: 'Subscription Period', sortable: false, thStyle: "width: 8%"},
				{key: 'payment_option', label: 'Payment Option', sortable: false, thStyle: "width: 8%"},
				{key: 'subscription_amount', label: 'Subscription Fee', sortable: false, thStyle: "width: 6%"},
				{key: 'vat_amount', label: 'VAT', sortable: false},
				{key: 'sd_amount', label: 'SD', sortable: false},
				{key: 'discount', label: 'Discount', sortable: false},
				{key: 'device_quantity', label: 'Device Quantity', sortable: false},
				{key: 'last_bill_generation_date', label: 'Last Bill Generation Date', sortable: false, thStyle: "width: 12%"},
				{key: 'next_bill_generation_date', label: 'Next Bill Generation Date', sortable: false, thStyle: "width: 12%"},
				{key: 'status', label: 'Status', sortable: false, thStyle: "width: 5%"},
				{key: 'actions', label: 'Actions', class : 'text-center'}
			],
			subscriptionToBeDeleted: {
      	id: null,
				projectName: null
			},
			deviceQuantity : 0,
			deviceUnitPrice : 0,
			softwarePackageFee : 0,
			deliveryDate : null,
			loading: false,
			searchParams : {
				perPage : 25,
				pageNumber : 0,
				searchKey : null
			},
			filterAndPaginationStatus: {
				totalPages: 0,
				currentPage: 0,
				searchKeyword: null
			}
    }
  },
  validations: {
    form: {
			purchaseOrderId: {
				required: requiredIf(vm => {
					return vm.pricingOption === 2;
				})
			},
			projectId: {
				required,
				minValue: minValue(1)
			},
      subscriptionPeriod: {
        required
      },
      pricingOption: {
        required
      },
      paymentOption: {
        required
      },
      amount: {
        required,
        minValue: minValue(1)
      },
      lateFeePercentage: {
        numeric,
        minValue: minValue(0)
      },
      trialEndDate: {
        required: requiredIf(vm=>{
          return vm.trialStartDate != null;
        })
      },
      billGenerationStartDate: {
        required
      },
      status: {
        required
      }
    },
		editForm: {
			amount: {
				minValue: minValue(1)
			},
		}
  },

	created() {
		// this.getProjectNames();
		// this.getSubscriptionPeriodList();
		// this.getPricingOptions();
		// this.getPaymentOptions();
		// this.getAllDeliveredPurchaseOrders();
		this.getAllSubscriptions();
	},

  methods: {
    checkFormValidity: function(){
      let formHasErrors = false;

      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        formHasErrors = true;
      }

      if(formHasErrors) return;
      else this.addNewSubscriber();
    },

    addNewSubscriber: function(){

      let trialStartDateInMillis = (this.trialStartDate != null) ? new moment(this.form.trialStartDate,'YYYY-MM-DD') : null;
      let trialEndDateInMillis = (this.trialEndDate != null) ? new moment(this.form.trialEndDate,'YYYY-MM-DD') : null;
      let billGenerationStartDateInMillis = new moment(this.form.billGenerationStartDate,'YYYY-MM-DD');
			let selectedProject = this.projectNameDropDownList.find((item) => item.value === this.form.projectId);

      const formData = {
				purchaseOrderId: this.form.purchaseOrderId,
				subscriberProjectId: this.form.projectId,
				subscriberProjectName: selectedProject.text.trim(),
				subscriptionPeriodId: this.form.subscriptionPeriod,
				pricingOptionId: this.form.pricingOption,
				paymentOptionId: this.form.paymentOption,
				amount: this.form.amount,
				lateFeePercentage: this.form.lateFeePercentage,
				trialStartDate: (trialStartDateInMillis != null) ? trialStartDateInMillis.format('x') : null,
				trialEndDate: (trialEndDateInMillis != null) ? trialEndDateInMillis.format('x') : null,
				billGenerationStartDate: billGenerationStartDateInMillis.format('x'),
				status: this.form.status
			};


      subscriptionService.subscribeAnOffice(formData, (data) => {
      	this.subscriptionList = [];
				this.createSubscriptionListTable(data);
				this.resetForm();
				toastService.showSuccessToast("Subscription added successfully");
			}, (error) => {
				toastService.showErrorToast("Could not store subscription data " + error);
			});

      return false;
    },

    resetForm: function(){
			this.$nextTick(() => { this.$v.$reset() });
    	this.form.purchaseOrderId = null;
      this.form.projectId = null;
      this.form.subscriptionPeriod = 2;
      this.form.pricingOption = 1;
      this.form.paymentOption = 1;
      this.form.status = 1;
      this.form.amount = null;
      this.form.lateFeePercentage = null;
      this.form.trialStartDate = null;
      this.form.trialEndDate = null;
      this.form.billGenerationStartDate = null;
    },

		getSubscriptionPeriodList: function () {
			subscriptionService.getSubscriptionPeriods((data) =>{
				this.subscriptionPeriodList = this.populateSubscriptionPeriodOptions(data);
			}, (error) => {
				toastService.showErrorToast("Could not fetch subscription periods" + error);
			});
		},

		getPricingOptions: function () {
			subscriptionService.getPricingOptions((data) => {
				this.pricingOptionList = this.populateRadioButtonOptions(data);
			}, (error) => {
				toastService.showErrorToast("Could not fetch pricing options " + error);
			});
		},

		getPaymentOptions: function () {
			subscriptionService.getPaymentOptions((data) =>{
				this.paymentOptionList = this.populateRadioButtonOptions(data);
			}, (error) => {
				toastService.showErrorToast("Could not fetch payment options " + error);
			});
		},

		populateRadioButtonOptions: function (data) {
    	let buttonOptions = [];
			data.forEach((value, index) => {
				let buttonOption = new Object();
				buttonOption.text = value.description;
				buttonOption.value = value.id;
				buttonOptions.push(buttonOption);
			});

			return buttonOptions;
		},

		populateSubscriptionPeriodOptions: function (data) {
			let buttonOptions = [];
			data.forEach((value, index) => {
				let buttonOption = new Object();
				buttonOption.text = value.title;
				buttonOption.value = value.id;
				buttonOptions.push(buttonOption);
			});

			return buttonOptions;
		},

		getAllSubscriptions: function () {
			this.loading = true;
			subscriptionService.getAllSubscriptions(this.searchParams, (data) => {
				this.filterAndPaginationStatus.totalPages = data.numberOfPages;
				this.filterAndPaginationStatus.currentPage = data.currentPage;
				this.filterAndPaginationStatus.searchKeyword = this.searchParams.searchKey;
				this.createSubscriptionListTable(data.subscriptionList);
				this.loading = false;
			}, (error) => {
				toastService.showErrorToast("Could not fetch subscriber list " + error);
			})
		},

		createSubscriptionListTable: function (data) {
			this.subscriptionList = [];
			data.forEach((value, index) => {
				let row = new Object();
				row.id = value.id;
				row.project_name = value.subscriberProjectName;
				row.bin = value.bin;
				row.invoice_number_prefix = value.invoiceNumberPrefix;
				row.address = value.address;
				row.subscription_period = value.subscriptionPeriod;
				row.payment_option = value.paymentOption;
				row.subscription_amount = value.amount.toFixed(2);
				row.vat_amount = value.vatAmount.toFixed(2);
				row.sd_amount = value.sdAmount.toFixed(2);
				row.discount = value.discount.toFixed(2);
				row.device_quantity = value.deviceQuantity;
				row.last_bill_generation_date = (value.lastBillGenerationDate != null) ? moment(value.lastBillGenerationDate).format('DD-MM-YYYY') : "N/A";
				row.next_bill_generation_date = (value.nextBillGenerationDate != null) ? moment(value.nextBillGenerationDate).format('DD-MM-YYYY') : "N/A";
				row.status = value.status;
				this.subscriptionList.push(row);
			});
		},
		getAllDeliveredPurchaseOrders : function () {
			purchaseOrderService.getAllDeliveredPurchaseOrders((data) => {
				this.purchaseOrderList = data;
				this.createPurchaseOrderDropDownList();
			}, (error) => {
				toastService.showErrorToast("Could not fetch purchase order list " + error);
			});
		},
		createPurchaseOrderDropDownList : function () {
			this.purchaseOrderList.forEach((value) => {
				let purchaseOrderOption = new Object();
				purchaseOrderOption.text = value.id + " - " + value.projectName + " - " + moment(value.purchaseDate).format('DD/MM/YYYY');
				purchaseOrderOption.value = value.id;
				this.purchaseOrderDropDownList.push(purchaseOrderOption);
			});
		},
		updateFormFieldsUponPricingOptionChange : function (pricingOption) {
    	if(pricingOption === 2) {
    		this.form.subscriptionPeriod = 3;
    		this.form.paymentOption = 1;
			} else {
    		this.form.projectId = null;
    		this.form.amount = null;
    		this.form.billGenerationStartDate = null;
			}
		},
		updateFormFieldsUponPurchaseOrderSelection : function (selectedPurchaseOrder) {
    	this.form.projectId = selectedPurchaseOrder.projectId;
    	this.form.amount = (selectedPurchaseOrder.softwarePackageFee + selectedPurchaseOrder.unitPrice) * selectedPurchaseOrder.deviceQuantity;
    	this.form.billGenerationStartDate = new moment(selectedPurchaseOrder.deliveryDate).add(366, 'days').format('yyyy-MM-DD');
    	this.deviceQuantity = selectedPurchaseOrder.deviceQuantity;
    	this.deviceUnitPrice = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'BDT' }).format(selectedPurchaseOrder.unitPrice.toFixed(2));
    	this.softwarePackageFee = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'BDT' }).format(selectedPurchaseOrder.softwarePackageFee.toFixed(2));
			this.deliveryDate = new moment(selectedPurchaseOrder.deliveryDate).format('DD/MM/yyyy');
		},
		getProjectNames : function () {
			customerService.getProjectNames((data) => {
				this.projectNames = data;
				this.createProjectNameDropDownList();
				this.loading = false;
			}, (error) => {
				this.loading = false;
				toastService.showErrorToast("Could not fetch project names " + error);
			});
		},
		createProjectNameDropDownList : function () {
			this.projectNames.forEach((value) => {
				let project = new Object();
				project.text = value.name;
				project.value = value.id;
				this.projectNameDropDownList.push(project);
			});
		},
		handleOk : function (event) {
			event.preventDefault();
			switch (event.componentId) {
				case "delete-confirmation-modal" :
					this.deleteSubscription();
					break;
				case "subscription-edit-modal" :
					this.checkEditFormValidity();
					break;
			}
		},
		deleteSubscription : function () {
			subscriptionService.deleteSubscription(this.subscriptionToBeDeleted.id, (data) => {
				this.subscriptionList = this.subscriptionList.filter((item) => item.id !== this.subscriptionToBeDeleted.id);
				this.$bvModal.hide("delete-confirmation-modal");
				this.cancelDeleteOperation();
				toastService.showSuccessToast("Subscription deleted successfully");
			}, (error) => {
				toastService.showErrorToast("Could not delete subscription " + error);
			})
		},
		openDeleteConfirmationModal : function (item) {
    	this.subscriptionToBeDeleted.id = item.id;
    	this.subscriptionToBeDeleted.projectName = item.project_name;
		},
		cancelDeleteOperation : function (){
			this.subscriptionToBeDeleted.id = null;
			this.subscriptionToBeDeleted.projectName = null;
		},
		showEditModal : function (item) {
			this.editForm.title = "<i class='icon-pencil'></i> Edit subscription for " + item.project_name;
			this.editForm.subscriptionId = item.id;
			this.editForm.bin = item.bin;
			this.editForm.address = item.address;
			this.editForm.invoiceNumberPrefix = item.invoice_number_prefix;
			this.editForm.amount = parseFloat(item.subscription_amount).toFixed(2);
			this.editForm.sdAmount = parseFloat(item.sd_amount).toFixed(2);
			this.editForm.discount = parseFloat(item.discount).toFixed(2);
		},
		checkEditFormValidity : function () {
			let formHasErrors = false;

			this.$v.editForm.$touch();
			if (this.$v.editForm.$anyError) {
				formHasErrors = true;
			}

			if(formHasErrors) return;
			else this.updateSubscription();
		},
		resetEditForm : function () {
			this.$nextTick(() => {
				this.$v.$reset();
				this.$bvModal.hide("subscription-edit-modal");
			});
			this.editForm.title = null;
			this.editForm.subscriptionId = null;
			this.editForm.amount = null;
			this.editForm.bin = null;
			this.editForm.address = null;
			this.editForm.invoiceNumberPrefix = null;
			this.editForm.sdAmount = null;
			this.editForm.discount = null;
		},
		updateSubscription : function () {
			const formData = {
				amount: this.editForm.amount,
				bin: this.editForm.bin,
				address: this.editForm.address,
				invoiceNumberPrefix: this.editForm.invoiceNumberPrefix,
				sdAmount: this.editForm.sdAmount,
				discount: this.editForm.discount
			};
			this.editForm.okTitle = "Please Wait..";
			this.editForm.disabled = true;

			subscriptionService.updateSubscription(this.editForm.subscriptionId, formData, (data) => {
				// this.subscriptionList.find(item => item.id === this.editForm.subscriptionId).subscription_amount = parseFloat(this.editForm.amount).toFixed(2);
				this.resetEditForm();
				this.getAllSubscriptions();
				toastService.showSuccessToast("Subscription update successful");
			}, (error) => {
				this.$nextTick(() => { this.$v.$reset() });
				toastService.showErrorToast("Could not update subscription " + error);
			}).finally(() => {
				this.editForm.okTitle = "Update";
				this.editForm.disabled = false;
			});
		},
		searchSubscription : function (pageIndex, keyword) {
			this.setParams(keyword, pageIndex);
			this.getAllSubscriptions();
		},
		setParams : function (keyword, pageIndex) {
			this.searchParams.searchKey = keyword;
			this.searchParams.pageNumber = pageIndex != null && !isNaN(pageIndex) ? pageIndex : 0;
		}
  },
  computed: {
  	tableData : function() {
  		return this.subscriptionList;
		},
		pricingOption : function () {
  		return this.form.pricingOption;
		},
		purchaseOrderId : function () {
  		return this.form.purchaseOrderId;
		}
  },
	watch: {
  	pricingOption : function (newVal) {
  		this.updateFormFieldsUponPricingOptionChange(newVal);
		},
		purchaseOrderId : function (newVal) {
  		if(newVal !== null) this.updateFormFieldsUponPurchaseOrderSelection(this.purchaseOrderList.find(item => item.id === newVal));
		}
	}
}
</script>

<style src="vue-search-select/dist/VueSearchSelect.css"></style>
